import FullScreenIcon from "@/common/images/icons/fullScreenIcon.svg?react";
import ExitFullScreenIcon from "@/common/images/icons/exitFullScreen.svg?react";
import { useAppStore } from "@/common/store/appStore";
import { mainBus } from "@/common/buses";
import { useCallback } from "react";
import "./FSButton.scss";

interface IFSButtonProps {
  gifId: string;
}

export const FSButton: React.FC<IFSButtonProps> = ({
  gifId
}) => {
  const isFullScreen = useAppStore((state) => state.isFullScreen);

  const handleToggleFullScreen = useCallback(() => {
    mainBus.emit("toggle_fullscreen", { id: gifId, isForceFS: false });
  }, [gifId]);

  return (
    <button onClick={handleToggleFullScreen} className="FSButton" aria-label={`${isFullScreen ? "close" : "open"} fullscreen`}>
      {isFullScreen ? <ExitFullScreenIcon /> : <FullScreenIcon />}
    </button>
  );
};
